import { createFileRoute } from "@tanstack/react-router";
import Konto from "../../../pages/account/Konto";

export const Route = createFileRoute("/_app/account/")({
	component: Konto,
});
